import React from 'react'

export const TemplateContext = React.createContext({})
